import React, { useContext } from "react";
import styled from "styled-components";
import { device } from "../../../WSUtils/constants/mediaQueries";
import { CvpButton } from "../../../Components/Buttons/CvpButton";
import { ButtonProps } from "primereact/button";
import { getRedirectProps } from "../../../WSUtils/urlUtils";
import { UserInfoContext } from "../../../WSUtils/UserInfoContext";
import { CVPSearchParams } from "../../../WSUtils/wsQueryStringStore";
import { observer } from "mobx-react";
import { withWSErrorContainer } from "../../../WSUtils/withWSErrorContainer";

const NewMsgBtn: React.FC<ButtonProps> = withWSErrorContainer(
  observer(({}) => {
    const userInfo = useContext(UserInfoContext);
    const { href, target, onClick } = getRedirectProps("/messages", {
      userInfo,
      mergeQs: {
        [CVPSearchParams.cvpmsgid]: "new",
      },
    });

    return (
      <StyledNewMsgBtn
        label="Ny melding"
        className="cvp-new-msg-btn"
        icon="pi pi-pencil"
        iconPos="left"
        onClick={onClick}
      />
    );
  })
);
export default NewMsgBtn;

export const StyledNewMsgBtn = styled(CvpButton)`
  &.cvp-new-msg-btn {
    &.p-button {
      padding: 1rem 2rem;
      display: flex;
      column-gap: 0.3rem;

      @media ${device.md} {
        padding: 1.3rem 3rem;
      }
    }
  }
`;
